import { render, staticRenderFns } from "./EventInfo.vue?vue&type=template&id=46c5569c&"
import script from "./EventInfo.vue?vue&type=script&lang=js&"
export * from "./EventInfo.vue?vue&type=script&lang=js&"
import style0 from "./EventInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports